import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CRM_ACCESS_SERVICE_TOKEN, CrmCoreModule } from '@galaxy/crm/static';
import { CRM_ROUTES, CrmModule } from '@galaxy/crm/dynamic';
import { CrmInjectionToken, CrmMultilocationInjectionToken } from './providers';
import { CRMAccessService } from './access.service';
import { CrmSendEmailComponent } from '@galaxy/crm/integrations/email-actions';

// Extend CRM routes with our custom send email route
const EXTENDED_CRM_ROUTES: Routes = [
  {
    path: 'send-email',
    component: CrmSendEmailComponent,
  },
  ...CRM_ROUTES,
];

@NgModule({
  imports: [
    RouterModule.forChild(EXTENDED_CRM_ROUTES),
    CrmCoreModule.forRoot(CrmInjectionToken, CrmMultilocationInjectionToken),
    CrmModule,
  ],
  providers: [
    { provide: CRM_ACCESS_SERVICE_TOKEN, useExisting: CRMAccessService },
  ],
})
export class BusinessCrmModule {}
